module.exports = __webpack_public_path__ + "static/media/valor2.d75c60b9.png";